export default {
    rulesForAdd: {
        'root': {
            'zone':true,
            'group':true,
            'ap':true,
        },
        'zone': {
            'zone':false,
            'group':false,
            'ap':true,
        },
        'group': {
            'zone':false,
            'group':false,
            'ap':true,
        },
        'ap': {
            'zone':false,
            'group':false,
            'ap':false,
        },
    },
    getRules: function(action,type){
        switch(action){
            case 'add':

                return this.rulesForAdd[this._transformType(type)];
                break;
        }

    },
    _transformType: function(type){
        return this.globalTypes[type];
    },
    globalTypes: {
        '0': 'root',
        '1': 'ap',
        '2': 'ap',
        '3': 'ap',
        '4': 'ap',
        '5': 'ap',
        '6': 'zone',
        '7': 'group',
    },
    types: {
        '1': 'wifi',
        '2': 'beacon',
        '3': 'nfc',
        '4': 'qrcode',
        '5': 'beacon',
        '6': 'zone',
        '7': 'group',
    },
    typesMasks: {
        '1': '##:##:##:##:##:##',
        '2': '################################:####:####',
        '3': '################################',
        '4': '',
        '5': '####################:############',
        '6': '',
        '7': '',
    },
    reverseTypes: {
        'wifi': [1],
        'beacon': [2,5],
        'nfc': [3],
        'qrcode': [4],
        'zone': [6],
        'group': [7],
    },
    realLabels: {
        '1': 'wifi',
        '2': 'ibeacon',
        '3': 'nfc',
        '4': 'qrcode',
        '5': 'eddystone',
        '6': 'zone',
        '7': 'group',
    }
}
